export const FILTER_TYPE = {
    "equals#true": "Filter list",
    "equals": "Custom filter list",
    "notEquals": "Does not equal",
    "contains": "Contains",
    "startsWith": "Starts With",
    "endsWith": "Ends With",
    "notContains": "Does not contain",    
    "set": "Exclude Null",
    "notSet": "Only Null",
    "gt": "Greater than",
    "gte": "Greater than or equal to",
    "lt": "Less than",
    "lte": "Less than or equal to",
    "inDateRange": "In Date Range",
    "notInDateRange": "Not In Date Range",
    "beforeDate": "Before Date",
    "afterDate": "After Date",
    "top": "Top",
    "bottom": "Bottom"
}

export const FILTER_TYPE_NEW = {
    "equals": "Filter list",
    "equals#true": "Custom filter list",
    "notEquals": "Does not equal",
    "contains": "Contains",
    "startsWith": "Starts With",
    "endsWith": "Ends With",
    "notContains": "Does not contain",    
    "set": "Exclude Null",
    "notSet": "Only Null",
    "gt": "Greater than",
    "gte": "Greater than or equal to",
    "lt": "Less than",
    "lte": "Less than or equal to",
    "inDateRange": "In Date Range",
    "notInDateRange": "Not In Date Range",
    "beforeDate": "Before Date",
    "afterDate": "After Date",
    "top": "Top",
    "bottom": "Bottom"
}

export const NUMBER_FILTER_TYPE = {
    "equals": "Equals",
    "notEquals": "Does not equal",
    "contains": "Contains",
    "notContains": "Does not contain",
    "set": "Exclude Null",
    "notSet": "Only Null",
    "gt": "Greater than",
    "gte": "Greater than or equal to",
    "lt": "Less than",
    "lte": "Less than or equal to",
    "inDateRange": "In Date Range",
    "notInDateRange": "Not In Date Range",
    "beforeDate": "Before Date",
    "afterDate": "After Date",
    "top": "Top",
    "bottom": "Bottom"
}

export const FIELD_TYPE_FILTERS = {
    number:[
        {value:'equals',label:'Equal To'},
        {value:'notEquals',label:'Not Equal To'},
        {value:'gt',label:'Greater Than'},
        {value:'gte',label:'Greaater than or Equal to'},
        {value:'lt',label:'Leass Than'},
        {value:'lte',label:'Leass Than or Equal to'},
        {value:'set',label:'Exclude Null'},
        {value:'notSet',label:'Only Null'}
    ],
    count:[
        {value:'equals',label:'Equal To'},
        {value:'notEquals',label:'Not Equal To'},
        {value:'gt',label:'Greater Than'},
        {value:'gte',label:'Greaater than or Equal to'},
        {value:'lt',label:'Leass Than'},
        {value:'lte',label:'Leass Than or Equal to'},
        {value:'set',label:'Exclude Null'},
        {value:'notSet',label:'Only Null'}
    ],
    string:[
        {value:'equals',label:'Filter List'},
        {value:'equals#true',label:'Custom Filter List'},
        {value:'notEquals',label:'Not Equal To'},
        {value:'contains',label:'Contains'},
        {value:'notContains',label:'Not Contains'},
        {value:'startsWith',label:'Starts With'},
        {value:'endsWith',label:'Ends With'},
        {value:'set',label:'Exclude Null'},
        {value:'notSet',label:'Only Null'}
    ],
    time:[
        {value:'equals',label:'Equal To'},
        {value:'notEquals',label:'Not Equal to'},
        {value:'set',label:'Exclude Null'},
        {value:'notSet',label:'Only Null'},
        {value:'inDateRange',label:'In Date Range'},
        {value:'notInDateRange',label:'Not In Date Range'},
        {value:'beforeDate',label:'Before Date'},
        {value:'afterDate',label:'After Date'}
    ]
}

export const INPUT_TYPE_TEXT_FILTER_TYPES = ['equals','notEquals','contains','notContains','startsWith','endsWith','gt','gte','lt','lte']
export const DATE_INPUT_FILTER_TYPES = ['afterDate','beforeDate']

export const GREATER_LESS_THAN_FILTER = ['gt', 'lt', 'gte', 'lte', 'equals', 'notEquals', 'top']

export const CURRENCIES = ['INR','USD','AED']